import React, { useState, useMemo } from 'react';
import {
  PageContainer,
  ContentWrapper,
  Header,
  FilterGroup,
  FilterButton,
  StatsBar,
  ProductsGrid,
  NoResults,
} from './ShopPage.styles';
import ProductCard from '../../components/ProductCard';
import { PRODUCTS_DATABASE } from '../../data/products';

const ShopPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  // Extrair categorias únicas (removendo 'Técnica' da lista de filtros)
  const categories = ['Todos', ...Array.from(new Set(PRODUCTS_DATABASE.map((p) => p.category))).filter((c) => c !== 'Técnica')];

  // Filtrar e ordenar produtos
  const filteredProducts = useMemo(() => {
    let filtered = PRODUCTS_DATABASE;

    // Filtro por categoria (inclui filtro especial Fingerstyle)
    if (selectedCategory !== 'Todos') {
      if (selectedCategory === 'Fingerstyle') {
          filtered = filtered.filter((p) => p.id === 'tablaturas' || p.title.toLowerCase().includes('fingerstyle'));
        } else {
        filtered = filtered.filter((p) => p.category === selectedCategory);
      }
    }

    // Mantém Coleção Completa sempre em primeiro
    const completeBook = filtered.find((p) => p.id === 'colecao-completa-13-1');
    const otherProducts = filtered.filter((p) => p.id !== 'colecao-completa-13-1');

    // Retornar Coleção Completa em primeiro, depois os outros (ordem original)
    return completeBook ? [completeBook, ...otherProducts] : otherProducts;
  }, [selectedCategory]);

  return (
    <PageContainer role="main" aria-label="Loja de e-books Violão Católico">
      <ContentWrapper>
        <Header>
          <h1>
            Nossa Loja de <span>E-books</span>
          </h1>
          <p>Cifras de qualidade para todo músico católico.</p>
        </Header>

        {/* Barra de busca e ordenação removida conforme solicitado */}

        <FilterGroup role="group" aria-label="Filtrar por categoria">
          {categories.map((category) => (
            <React.Fragment key={category}>
              <FilterButton
                key={`${category}-btn`}
                active={selectedCategory === category}
                onClick={() => setSelectedCategory(category)}
                role="radio"
                aria-checked={selectedCategory === category}
              >
                {category}
              </FilterButton>

              {/* inserir o filtro Fingerstyle logo após 'Coleções' */}
              {category === 'Coleções' && (
                <FilterButton
                  key="Fingerstyle"
                  active={selectedCategory === 'Fingerstyle'}
                  onClick={() => setSelectedCategory('Fingerstyle')}
                  role="radio"
                  aria-checked={selectedCategory === 'Fingerstyle'}
                >
                  Fingerstyle
                </FilterButton>
              )}
            </React.Fragment>
          ))}
        </FilterGroup>

        <StatsBar>
          <span 
            className="results-count"
            role="status"
            aria-live="polite"
          >
            {filteredProducts.length} produto{filteredProducts.length !== 1 ? 's' : ''} encontrado
            {filteredProducts.length !== 1 ? 's' : ''}
          </span>
        </StatsBar>

        {filteredProducts.length > 0 ? (
          <ProductsGrid role="grid">
            {filteredProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </ProductsGrid>
        ) : (
          <NoResults role="status">
            <h3>Nenhum produto encontrado</h3>
            <p>Tente ajustar seus filtros ou termos de busca</p>
          </NoResults>
        )}
      </ContentWrapper>
    </PageContainer>
  );
};

export default ShopPage;
